import { useState, useEffect } from "react";

import axios from "axios";
import { Link } from "react-router-dom";
const Dashboard = () => {
  const [userData, setUserData] = useState("");
  const [thirdPartyAuthToken, setThirdPartyAuthToken] = useState(null);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_name");
    localStorage.removeItem("user_email");
    localStorage.removeItem("user_role");
    window.location.href = "/";
  };

  const fetchUserData = async (accessToken) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + "/user", {
        params: { q: "isInternalUser" },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      setUserData(response.data.data);
      setThirdPartyAuthToken(response.data.thirdPartyAuthToken || null);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const accessToken = localStorage.getItem("token");
    if (!accessToken) {
      window.location.href = "/";
    }

    fetchUserData(accessToken);
  }, []);

  return (
    <div className="container px-4 py-2">
      <div className="text-end ">
        <button className="btn btn-dark" style={{ fontSize: "small" }} onClick={handleLogout}>
          Logout
        </button>
      </div>
      <div className="my-4 my-md-5 h2 text-center">Welcome!!</div>

      <div className="row justify-content-center align-items-center gap-4">
        <div className="col-lg-3">
          <Link to="/fileupload" style={{ textDecoration: "none" }}>
            <h4
              style={{ backgroundColor: "#8e44ad", color: "#fff", minHeight: "100px" }}
              className=" app-btn app-btn-1 text-center d-flex align-items-center justify-content-center rounded shadow"
            >
              TP Tool
            </h4>
          </Link>
        </div>
        {thirdPartyAuthToken && (
          <div className="col-lg-3">
            <a style={{ textDecoration: "none" }} className="" href={`https://tc.tpdetector.com?ref_token=${thirdPartyAuthToken}`} target="_blank">
              <h4
                style={{ backgroundColor: "#f4ecf7", color: "#633483", border: "1px solid", minHeight: "100px" }}
                className=" app-btn app-btn-2 text-center d-flex align-items-center justify-content-center rounded shadow"
              >
                Title Check
              </h4>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
